import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Sidebar({ currentUser, onLogout, unreadAlertas, open, onClose }) {
  const rol = currentUser.rol;
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { id: "dashboard", icon: "ph-squares-four", label: "Panel de Mando", path: "/" },
    { id: "registros", icon: "ph-drop", label: "Registros de Planta", path: "/registros" },
    { id: "ensayos", icon: "ph-flask", label: "Ensayos Jarras", path: "/ensayos" },
    { id: "lavado-filtros", icon: "ph-arrows-clockwise", label: "Lavado de Filtros", path: "/lavado-filtros" },
    { id: "inventario", icon: "ph-package", label: "Inventario", path: "/inventario" },
    ...(rol !== "operario" ? [
      { id: "graficas", icon: "ph-chart-line-up", label: "Panel de Gráficos", path: "/graficas" },
      { id: "gerencia", icon: "ph-presentation-chart", label: "Informe Gerencial", path: "/gerencia" },
      { id: "informes", icon: "ph-files", label: "Informes Registrados", path: "/informes" },
      { id: "prediccion", icon: "ph-chart-line", label: "Predicción y Clima", path: "/prediccion" },
      { id: "reporte", icon: "ph-file-xls", label: "Reporte Mensual", path: "/exportar" },
      { id: "importar", icon: "ph-upload-simple", label: "Carga Masiva", path: "/importar" }
    ] : []),
    ...((rol === "administrador" || rol === "administrador_ti") ? [
      { id: "registros-mes", icon: "ph-calendar-check", label: "Registros Mensuales", path: "/registros-mes" }
    ] : []),
    ...(rol === "administrador_ti" ? [
      { id: "usuarios", icon: "ph-users", label: "Personal", path: "/usuarios" },
      { id: "logs", icon: "ph-shield-check", label: "Auditoría (Logs)", path: "/logs" },
      { id: "seguridad", icon: "ph-lock-key", label: "Seguridad", path: "/seguridad" }
    ] : []),
    { id: "alertas", icon: "ph-bell", label: "Alertas", badge: unreadAlertas, path: "/alertas" },
    { id: "bitacora", icon: "ph-notebook", label: "Bitácora", path: "/bitacora" }
  ];

  return (
    <aside className={`sidebar ${open ? 'open' : ''}`}>
      <div onClick={() => navigate("/")} className="sidebar-logo" style={{ cursor: 'pointer' }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "50px", height: "50px", flexShrink: 0 }}>
          <img src="/img/logo.png" alt="AquaReport Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
        </div>
        <div className="sidebar-logo-text">
          <span className="sidebar-logo-title">AquaReport</span>
        </div>
      </div>

      <nav style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden" }}>
        <ul className="nav-menu">
          {items.map(item => {
            const isActive = location.pathname === item.path || (item.path !== "/" && location.pathname.startsWith(item.path));
            return (
              <li key={item.id}>
                <button
                  onClick={() => { navigate(item.path); if (window.innerWidth <= 900) onClose?.(); }}
                  className={`nav-item ${isActive ? 'active' : ''}`}
                  style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'left', cursor: 'pointer' }}
                >
                  <i className={`ph${isActive ? '-fill' : ''} ${item.icon}`}></i> {item.label}
                  {item.badge > 0 && <span style={{ marginLeft: "auto", background: "#ef4444", color: "#fff", borderRadius: 99, padding: "1px 7px", fontSize: 11, fontWeight: 700 }}>{item.badge}</span>}
                </button>
              </li>
            );
          })}
        </ul>

        <div className="sidebar-footer" style={{ display: "flex", flexDirection: "column", gap: "0.25rem", flexShrink: 0 }}>
          <button className="nav-item" style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'left', cursor: 'pointer' }}>
            <i className="ph ph-question"></i> Ayuda
          </button>
          <button onClick={onLogout} className="nav-item" style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'left', cursor: 'pointer' }}>
            <i className="ph ph-sign-out"></i> Cerrar Sesión
          </button>
        </div>
      </nav>
    </aside>
  );
}
